// extracted by mini-css-extract-plugin
module.exports = {"badge":"WinningLabel_badge__ouaDj","align-center":"WinningLabel_align-center__30UXV","icon":"WinningLabel_icon__dZuAw","emoteAppearing":"WinningLabel_emoteAppearing__WIZ2E"};